import { HttpParams } from '@angular/common/http';

export class ListFailedPaymentFilter {
    service: string | undefined;
    plan: string | undefined;
    firstName: string | undefined;
    lastName: string | undefined;
    code: string | undefined;
    email: string | undefined;
    partner: string | undefined;

    constructor(filter?: ListFailedPaymentFilter) {
        if (filter) {
            this.service = filter.service;
            this.partner = filter.partner;
            this.plan = filter.plan;
            this.firstName = filter.firstName;
            this.lastName = filter.lastName;
            this.code = filter.code;
            this.email = filter.email;
            this.partner = filter.partner;
        }
    }

    getHttpParams(httpParams = new HttpParams()): HttpParams {
        if (this.service) {
            httpParams = httpParams.set('serviceId', this.service);
        }
        if (this.partner) {
            httpParams = httpParams.set('partnerId', this.partner);
        }
        if (this.plan) {
            httpParams = httpParams.set('planId', this.plan);
        }
        if (this.firstName) {
            httpParams = httpParams.set('nameCustomer', this.firstName);
        }
        if (this.lastName) {
            httpParams = httpParams.set('lastNameCustomer', this.lastName);
        }
        if (this.code) {
            httpParams = httpParams.set('codeCustomer', this.code);
        }
        if (this.email) {
            httpParams = httpParams.set('email', this.email);
        }
        return httpParams;
    }
}